import { useState } from "react";
import { downloadPoints } from "@/mocks/gossip";

export default function DownloadCta() {
  const [email, setEmail] = useState("");
  const [joined, setJoined] = useState(false);

  const join = () => {
    if (!email.trim()) return;
    setJoined(true);
  };

  return (
    <section id="download" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-2xl border border-primary-200 bg-gradient-to-br from-background-100 via-background-50 to-accent-100/60 px-5 py-10 md:px-10 md:py-14">
          <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-accent-500/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-16 -left-8 h-56 w-56 rounded-full bg-primary-600/10 blur-3xl" />

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-foreground-950 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-download-2-line" /> 最近黑料 客户端 / 电子周刊
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-950 md:text-3xl">
                把「风口浪尖」装进口袋，
                <br className="hidden sm:block" /> 快讯到了再第一时间读
              </h2>
              <ul className="mt-5 space-y-2.5">
                {downloadPoints.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-600" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="#download" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-foreground-800">
                  <i className="ri-apple-fill" /> iOS 客户端
                </a>
                <a href="#download" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-foreground-800">
                  <i className="ri-android-fill" /> Android
                </a>
                <a href="#download" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/25 px-5 py-2.5 text-sm font-medium text-foreground-900 hover:border-primary-500 hover:text-primary-700">
                  <i className="ri-global-line" /> Web 版
                </a>
              </div>
            </div>

            {/* subscribe panel */}
            <div className="rounded-xl border border-foreground-950/10 bg-background-50/90 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950">订阅每日电子周刊</h3>
              <p className="mt-1.5 text-sm text-foreground-600">
                每天早晨 8 点，收到当天新涉事者与事件还原的核心摘要，附信源时点清单。
              </p>
              <div className="mt-4 flex flex-col gap-2.5 sm:flex-row">
                <label className="sr-only" htmlFor="weekEmail">邮箱地址</label>
                <input
                  id="weekEmail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@example.com"
                  className="w-full rounded-md border border-foreground-950/15 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-400/30"
                />
                <button
                  type="button"
                  onClick={join}
                  className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700"
                >
                  免费订阅
                </button>
              </div>
              {joined && (
                <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-primary-700">
                  <i className="ri-checkbox-circle-line" /> 已把 {email} 加入周刊队列（演示，不会真正发送）
                </p>
              )}
              <p className="mt-4 text-[11px] leading-relaxed text-foreground-500">
                可随时退订；周刊仅整理背景梳理与事件还原摘要，不含主观判断与引流外链。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}